<div class="insights-container">
  <mat-drawer-container>
    <mat-drawer [mode]="'side'" [opened]="true">
      <project-insights-sidebar></project-insights-sidebar>
    </mat-drawer>

    <mat-drawer-content>
      <section class="w-full">
        <router-outlet></router-outlet>
      </section>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
